import { render } from "./ModalCustomizeAudienceList.vue?vue&type=template&id=39eb65b1&scoped=true"
import script from "./ModalCustomizeAudienceList.vue?vue&type=script&lang=js"
export * from "./ModalCustomizeAudienceList.vue?vue&type=script&lang=js"

import "./ModalCustomizeAudienceList.vue?vue&type=style&index=0&id=39eb65b1&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eb65b1"]])

export default __exports__